import { AGE_GROUPS, EVENT_STATUS, EVENT_TIMEFRAMES } from "utils/helpers/enums/shared.enum";
import { FilterDTO } from "../shared/filter.dto";

export class MinorEventsFilterDTO extends FilterDTO {
    searchTitle: string = '';
    ageGroups: AGE_GROUPS;
    status: EVENT_STATUS;
    timeFrame: EVENT_TIMEFRAMES.UPCOMING;
    isSession: string = '';
    hostId: number;
    childId: number;

    constructor(data: Partial<MinorEventsFilterDTO> = {}) {
        super();
        for (let key in data) {
            this[key] = data[key];
        }
    }
}